// Paliers nommés (3D) du pouvoir Zone selon le total de lignes mises en banque.
// Pur — utilisé pour l'affichage et le crescendo de sortie de Zone.
// NB : « TESSERAX » est le nom du feat 4D du Pli (cf. core/clears.tesseraName), pas un palier Zone —
// les paliers Zone gardent un lexique polycube DISTINCT (TÉTRADE…OMNICUBE) pour ne pas brouiller la
// lecture. (Anciennement 3=TESSERA / 28=TESSERAX, renommés quand le Pli a pris le nom du jeu.)
export const ZONE_TIERS: [number, string][] = [
  [28, 'OMNICUBE'], [18, 'HYPERCUBE'], [12, 'DÉCACUBE'], [9, 'ENNÉACUBE'], [6, 'HEXACUBE'], [3, 'TÉTRADE'],
];

export function zoneTier(n: number): string {
  for (let i = 0; i < ZONE_TIERS.length; i++) if (n >= ZONE_TIERS[i][0]) return ZONE_TIERS[i][1];
  return '';
}

// Durée de la fenêtre Zone, ÉTIRÉE par la maîtrise (Profondeur) : une Zone obtenue
// tard récompense le joueur d'un peu plus de temps figé. +0,4 s par niveau, plafonnée
// à +3 s (≈ 18 s à Profondeur 8+) au-dessus de la base `baseMs`. Plafond ABAISSÉ 6 → 3 s :
// la Zone profonde restait un robinet de sauvetage trop long (≈21 s de clears gratuits) ;
// on rabote ce filet sans toucher à son rôle de pic de score. Pure → testable et réutilisée
// par l'activation ET par le dénominateur de la barre de Zone (main.ts).
export function zoneDurationMs(level: number, baseMs: number): number {
  return baseMs + Math.min(3000, Math.max(0, level - 1) * 400);
}
